import {
  AgxButton,
  AgxModal,
  AgxSpacer,
  AgxTypography,
  Icon_AlertCircleOutline,
  Icon_FeaturedIcon,
  type AgxDialogControlProps,
} from '@urbanx/agx.ui-components2';
import { tokens } from '@urbanx/agx.ui-components2/tokens';

interface DisableAgencyActivitiesDialogProps extends AgxDialogControlProps {
  onConfirm: () => void;
}

export default function DisableAgencyActivitiesDialog({
  isOpen,
  setIsDialogOpen,
  onConfirm,
}: DisableAgencyActivitiesDialogProps) {
  return (
    <AgxModal
      id="disable-agency-activities"
      isOpen={isOpen}
      setIsDialogOpen={setIsDialogOpen}
      title="Turn off automatic task generation?"
      titleIcon={
        <Icon_FeaturedIcon
          showRings={false}
          icon={<Icon_AlertCircleOutline type="Danger" />}
          color={tokens.text.error}
          backgroundColor={tokens.bg.errorLight}
        />
      }
      type="single"
      maxWidth="600px"
      variant="withoutDivider"
      actionButtonContainerStyle="withDivider"
      content={
        <AgxSpacer
          direction="vertical"
          padding={{ top: 'md', bottom: 'md', left: 'xl', right: 'xl' }}
        >
          <AgxTypography type="body" size="medium" color={tokens.text.secondary}>
            Tasks will no longer be generated for this agency while automatic task generation is
            off. Existing tasks will not be deleted. Do you want to continue?
          </AgxTypography>
        </AgxSpacer>
      }
      actionButtons={
        <AgxSpacer direction="horizontal" gap="spacing-xl" contentJustification="center" fill>
          <AgxButton
            id="cancel-disable-agency-activities"
            text="Cancel"
            size="large"
            stretch
            variant="hollow"
            onClick={() => setIsDialogOpen(false)}
          />
          <AgxButton
            id="confirm-disable-agency-activities"
            variant="primary"
            text="Turn off"
            size="large"
            stretch
            danger
            onClick={() => {
              setIsDialogOpen(false);
              onConfirm();
            }}
          />
        </AgxSpacer>
      }
    />
  );
}
